import { Tabs } from '@mantine/core';
import { ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { AdverseEventsTab } from './AdverseEvents/AdverseEventsTab';
import { EngagementTab } from './Engagement/EngagementTab';
import { WeightLossTab } from './WeightLoss/WeightLossTab';

const TABS = ['engagement', 'weight-loss', 'adverse-events'] as const;
type PostProcedureTab = (typeof TABS)[number];
const DEFAULT_TAB: PostProcedureTab = 'engagement';

function isValidTab(value: string | null): value is PostProcedureTab {
  return value !== null && (TABS as readonly string[]).includes(value);
}

export function PostProcedurePage(): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab = isValidTab(tabParam) ? tabParam : DEFAULT_TAB;

  const handleTabChange = (value: string | null): void => {
    if (!isValidTab(value)) {
      return;
    }
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('tab', value);
      return next;
    });
  };

  return (
    <Tabs value={activeTab} onChange={handleTabChange} keepMounted={false}>
      <Tabs.List>
        <Tabs.Tab value="engagement">Engagement</Tabs.Tab>
        <Tabs.Tab value="weight-loss">Weight Loss</Tabs.Tab>
        <Tabs.Tab value="adverse-events">Adverse Events</Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="engagement">
        <EngagementTab />
      </Tabs.Panel>
      <Tabs.Panel value="weight-loss">
        <WeightLossTab />
      </Tabs.Panel>
      <Tabs.Panel value="adverse-events">
        <AdverseEventsTab />
      </Tabs.Panel>
    </Tabs>
  );
}
